import Api from './api';

const consigneesListRequest = (userId) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/consignees?user_id=' + userId, {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const createConsigneeRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/consignees/', data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const deleteConsigneeRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().delete('/api/consignee/' + id, { headers:
        {
            Authorization: 'Bearer ' + access_token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }

    })
}


export default { consigneesListRequest, createConsigneeRequest, deleteConsigneeRequest }



// WEBPACK FOOTER //
// ./src/api/apiConsignees.js